import React from 'react';
import { Accordion } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';

export const ArrearsInformationAccordion: React.FC = () => {
    const { t } = useTranslation('arrears-information');

    return (
        <Accordion>
            <Accordion.Item title={t('title')}>
                <div
                    className="u-mb-large"
                    dangerouslySetInnerHTML={{
                        __html: t('subText'),
                    }}
                />
                <div
                    dangerouslySetInnerHTML={{
                        __html: t('links'),
                    }}
                />
            </Accordion.Item>
        </Accordion>
    );
};
